import React from "react";

interface Props {
  condition: boolean;
}

const IF: React.FC<Props> = ({ condition, children }) =>
  condition ? <>{children}</> : <></>;

export default IF;
